
    import { mapGetters } from 'vuex';

    export default {
        name: 'JobViewJd',

        props: {
            jobBody: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                isOpen: true,
            };
        },

        computed: {
            ...mapGetters('job', {
                $_jobBody: 'jobBody',
            }),

            label() {
                return this.isOpen ? 'CLOSE' : 'READ MORE';
            },
        },

        methods: {
            toggle() {
                this.isOpen = !this.isOpen;
                if (!this.isOpen) {
                    window.scroll({
                        top: document.getElementById('jvDescription')?.offsetParent.offsetTop,
                        behavior: 'auto',
                        block: 'start',
                    });
                }
            },
        },
    };
